export enum Devices {
    MOBILE = 'mobile',
    DESKTOP = 'desktop',
    TABLET = 'tablet'
}

export type DeviceType = Devices.DESKTOP | Devices.TABLET | Devices.MOBILE;

export function getDeviceType(windowWidth: number): DeviceType {
    if (windowWidth > 1024) return Devices.DESKTOP
    if (windowWidth > 767) return Devices.TABLET
    return Devices.MOBILE
}

export function transform(str: string): any {
    str = str.replace(/®/g, '');
    str = str.replace(/\//g, '');
    str = str.replace(/™/g, '');
    str = str.replace(/\+/g, '');
    str = str.replace(/<sup>/g, '');
    str = str.replace(/<\/sup>/g, '');
    str = str.replace(/<sub>/g, '');
    str = str.replace(/<\/sub>/g, '');
    str = str.replace(/&#126;/g, '~');
    str = str.replace(/\<br\>/g, ' ');
    str = str.replace(/►/g, ''); 
    return str;
}